import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, Collapse, Tooltip } from '@mui/material/';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare, faChevronDown, faChevronRight, faStar } from '@fortawesome/free-solid-svg-icons';
import { Box } from '@mui/material';
import { EnhancedTableHead } from '../../components/EnhancedTableHead';
import { genUID } from '../../common/StaticExports';
import TableSkeleton from '../../components/TableSkeleton';
import CommentsDocsActionsIconWrapper from '../../components/CommentsDocsActionsIconWrapper';
import SelectBoxPrimary from '../../components/SelectBoxPrimary';
import StatusIndicatorSmall from '../../components/StatusIndicatorSmall';
import { colors } from '../../common/pallette/colors';
import { fetchCriteriaSesions, getClubReviewsInfo, getCriteriaComments, getCriteriaCommentsHistory, getOnSiteCriteriaComments, getOnSiteQuestions, syncQuestions } from '../../api/evaluation';
import { resetOnSiteStandards, resetSelectedOnSiteCriteria, setCommentContent, setCriteriaComment, setCriteriaCommentsHistory, setOnSiteCriteriaComments, setOnSiteStandards, setSelectedOnSiteCriteria } from '../../redux/reducers/evaluation';
import { useTranslation } from 'react-i18next';
import InterviewStandardDetails from '../StandardsDetail/InterviewStandardDetails';
import { sortData } from '../../common/SortSupport';
import InterviewStandardDetailsPopup from '../StandardsDetail/InterviewStandardDetailsPopup';
import { useNavigate } from 'react-router';

const InterviewStandards = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const standards = useSelector((state:any) => state.evaluation.onSiteStandards);
  const interviewDetails = useSelector((state:any) => state.evaluation.interviewDetails);
  const currentClub = useSelector((state:any) => state.clubDetails);
  const selectedOnSiteSession = useSelector((state:any) => state.evaluation.selectedOnSiteSession);
  const selectedOnSiteCriteria = useSelector((state:any) => state.evaluation.selectedOnSiteCriteria);
  const isFetchingInterviewDetails = useSelector((state:any) => state.evaluation.isFetchingInterviewDetails);
  const onSiteStandards = useSelector((state:any) => state.evaluation.onSiteStandards);
  const clubDetails = useSelector((state:any) => state.clubDetails);
  const [isOpen, setIsOpen] = React.useState(999);
  const [isFetching, setIsFetching] = useState(false);
  const [t] = useTranslation();
  const [openStandard, setOpenStandard] = React.useState(999);
  const [detail, setDetail] = React.useState(Object);
  const [isOpenStandards, setIsOpenStandards] = React.useState(false);

  //supporting contents
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('standardUid');
  const [orderC, setOrderC] = React.useState('asc');
  const [orderByC, setOrderByC] = React.useState('uid');

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  
  let visibleRows = React.useMemo(
    () =>
      standards && standards.length > 0 &&
      sortData(standards, orderBy, order),
    [order, orderBy, standards],
  );
  let visibleRowsC = React.useMemo(
    () =>
      interviewDetails && interviewDetails.length > 0 &&
      sortData(interviewDetails, orderByC, orderC),
    [orderC, orderByC, interviewDetails],
  );

  const head = [
    {
      key: 'uid', displayName: 'id',
    },
    {
      key: 'name', displayName: 'criteria',
    },
    {
      key: '', displayName: '',
    },
    {
      key: 'offSiteStatus', displayName: 'Off-Site',
    },
    {
      key: '', displayName: 'on site rating',
    },
    {
      key: '', displayName: '',
    },
  ];

    const standardsHead = [
    {
      key: 'uid', displayName: 'id',
    },
    {
      key: 'name', displayName: 'standards',
    },
    {
      key: '', displayName: '',
    },
    {
      key: '', displayName: '',
    },
    {
      key: 'star', displayName: 'star',
    },
    {
      key: 'offSiteStatus', displayName: 'Off-Site',
    },
    {
      key: '', displayName: 'on site rating',
    },
  ];

  const initialOnSiteCommentObj = {
      "id": null,
      "comment": "",
      "criteriaId": selectedOnSiteCriteria?.id,
      "clubId": clubDetails?.id,
      "userAvatarPath": null,
      "updatedUserFirstName": null,
      "updatedUserLastName": null,
      "updatedDate": null,
      "sessionId": selectedOnSiteSession?.id,
  }

  const fetchStandards = async (criteria:any) => {
    setIsFetching(true);
    dispatch(resetOnSiteStandards());
    const reviewData = await getClubReviewsInfo({clubId: currentClub?.id});
    getOnSiteQuestions({onSiteReviewId: reviewData?.onSiteReviewId, sessionId: selectedOnSiteSession?.id, criteriaId: criteria?.id})
    .then((res:any) => {
      const criteriaUID = criteria?.uid.match(/^[A-Za-z]+(\d+)/)?.[1];
      const standardUID = res?.answers[0]?.standardUid.match(/^[A-Za-z]+(\d+)/)?.[1];
      if (criteriaUID === standardUID) {
        dispatch(setOnSiteStandards(res?.answers));
        setIsFetching(false);
      } else {
        dispatch(resetOnSiteStandards());
        setIsFetching(false);
      }
    });
  }

  const fetchOnSiteCriteriaComments = async (data:any) => {
    if(data && data?.id && currentClub && currentClub?.id) {
      // const criteriaSessions = await fetchCriteriaSesions({clubId: currentClub.id, criteriaId: data.id});
      const response = await getOnSiteCriteriaComments({clubId: currentClub?.id, criteriaId: data?.id});
      var filteredArr = response.filter((item:any) => item?.sessionId == selectedOnSiteSession?.id);
            if (filteredArr?.length == 0) filteredArr = [initialOnSiteCommentObj];
      dispatch(setOnSiteCriteriaComments(filteredArr || []));
      if(filteredArr) {
        const tempObj = filteredArr.find((item:any) => (item.criteriaId  == data?.id && item.sessionId == selectedOnSiteSession.id));
        dispatch(setCommentContent(tempObj));
      }
    }
  }

  const fetchCriteriaLevelComments = (data:any) => {
    getCriteriaComments({ clubId: clubDetails?.id, criteriaId: data.id})
    .then((res:any) => {
      dispatch(setCriteriaComment(res));
    });
    getCriteriaCommentsHistory({ clubId: clubDetails.id, criteriaId: data.id})
    .then((historyRes:any) => {
        dispatch(setCriteriaCommentsHistory(historyRes));
    })
  }

  const updateStatus = async (value:any, std:any) => {
    if (standards) {
      const tempArr = standards?.map((item:any) => {
        if(item.standardId == std.standardId) {
          return {...std, status: value};
        } return item;
      });
      const reviewData = await getClubReviewsInfo({clubId: currentClub?.id});
      const response = await syncQuestions({onSiteReviewId: reviewData?.onSiteReviewId, sessionId: selectedOnSiteSession?.id, questions: tempArr});
      response && dispatch(setOnSiteStandards(tempArr));
    }
  }

  const updateOnsiteDetails = async (updatedOnSiteData:any) => {
      const tempArr = standards?.map((item:any) => {
        if(item.standardId == updatedOnSiteData.standardId) {
          return updatedOnSiteData;
        } return item;
      });
      const reviewData = await getClubReviewsInfo({clubId: currentClub?.id});
      const response = await syncQuestions({onSiteReviewId: reviewData?.onSiteReviewId, sessionId: selectedOnSiteSession?.id, questions: tempArr});
      response && dispatch(setOnSiteStandards(tempArr));
  }

  useEffect(() => {
    if (!onSiteStandards && selectedOnSiteCriteria && selectedOnSiteCriteria?.id && !isFetching) {
        fetchStandards(selectedOnSiteCriteria);
        fetchOnSiteCriteriaComments(selectedOnSiteCriteria);
        fetchCriteriaLevelComments(selectedOnSiteCriteria);
    }
  }, [selectedOnSiteCriteria])

  //table contents
    return(
        <React.Fragment>
            <InterviewStandardDetailsPopup detail={detail} manageUpdate={updateOnsiteDetails} isOpen={isOpenStandards} handleClose={() => { setIsOpenStandards(false); navigate(`/onsite/sessions/${selectedOnSiteSession?.id}/criteria/${selectedOnSiteCriteria?.id}/standards`); }} />
            <Box sx={{ position: 'relative' }}>
            {/* umcomment the below line to enable open popup */}
            {/* <SAStandardsDetail isOpen={isOpenStandard} detail={detail} handleClose={() => setIsOpenStandard(false)}/> */}
              <TableContainer sx={{ overflowY: 'auto' }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    bg={colors.white.bright}
                    />
                    {
                      !isFetchingInterviewDetails && visibleRowsC && visibleRowsC?.length ?
                      <TableBody>
                        {
                          visibleRowsC?.map((d: any, i: number) => (
                            <>
                              <TableRow
                              className={selectedOnSiteCriteria?.id == d.id ? 'selectedRow' : 'hoverBG'}
                              sx={{ cursor: 'pointer' }}
                              key={`interview-criteria-table-row-${i}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                dispatch(resetSelectedOnSiteCriteria());
                                dispatch(setSelectedOnSiteCriteria(d));
                                let num = i == isOpen ? 999 : i;
                                setIsOpen(num);
                                i == isOpen ?
                                navigate(`/onsite/sessions/${selectedOnSiteSession?.id}/criteria/${d?.id}`) :
                                navigate(`/onsite/sessions/${selectedOnSiteSession?.id}/criteria/${d?.id}/standards`);
                                if (i != isOpen && selectedOnSiteSession && selectedOnSiteSession?.id && d?.id &&
                                  selectedOnSiteCriteria.id !== d.id) {
                                  fetchStandards(d);
                                  fetchOnSiteCriteriaComments(d);
                                  fetchCriteriaLevelComments(d);
                                  dispatch(resetOnSiteStandards());
                                  setOpenStandard(999);
                                }
                              }}
                              >
                                <TableCell className='fs12'>{genUID(d.uid)}</TableCell>
                                <TableCell className='fs12' sx={{ width: '56%' }} >{d.name}</TableCell>
                                <TableCell className='fs12'>
                                  <CommentsDocsActionsIconWrapper 
                                  actions={d.noOfActions} 
                                  comments={d.noOfComments} 
                                  docs={d.noOfEvidences}
                                  showDetailedCount={true}
                                  jlComments={d.noOfJLComments}
                                  clubComments={d.noOfClubComments} />
                                </TableCell>
                                <TableCell className='fs12' >
                                    <StatusIndicatorSmall reportType={'siteReview'} status={d.offSiteStatus} />
                                </TableCell>
                                <TableCell className='fs12' >
                                  <StatusIndicatorSmall reportType={'siteReview'} status={d.onSiteStatus} />
                                </TableCell>
                                <TableCell >
                                    {isOpen == i && selectedOnSiteCriteria?.id == d?.id ? <FontAwesomeIcon className='icon' icon={faChevronDown} /> : <FontAwesomeIcon className='icon' icon={faChevronRight} />}
                                </TableCell>
                              </TableRow>
                              {/* collapsible row */}
                              <TableRow className={isOpen == i && selectedOnSiteCriteria?.id == d?.id ? '' : 'displayNone'}>
                                <TableCell colSpan={7}>
                                  <Collapse in={isOpen == i && selectedOnSiteCriteria?.id == d?.id}>
                                  {
                                  <Table stickyHeader size="small" aria-label="a dense table">
                                      <EnhancedTableHead
                                      order={order}
                                      orderBy={orderBy}
                                      onRequestSort={handleRequestSort}
                                      tableHeads={standardsHead}
                                      bg={colors.white.bright}
                                      />
                                      {
                                        selectedOnSiteCriteria !== null && visibleRows !== null && visibleRows?.length > 0 &&                                  
                                        visibleRows[0]?.standardUid !== null && selectedOnSiteCriteria?.uid != null &&
                                        selectedOnSiteCriteria?.uid.match(/^[A-Za-z]+(\d+)/)?.[1] == visibleRows[0]?.standardUid.match(/^[A-Za-z]+(\d+)/)?.[1] &&
                                        !isFetching && i == isOpen && visibleRows && visibleRows.length ?
                                        visibleRows.map((standard:any, j:any) => {
                                            return (
                                              <>
                                              <TableRow
                                              className='hoverBG'
                                              sx={{ cursor: 'pointer' }}
                                              key={`interview-standards-table-row-${i}`}
                                              onClick={() => {
                                                let num = j == openStandard ? 999 : j;
                                                if (num == 999) {
                                                  setDetail(Object);
                                                } else {
                                                  setDetail(standard);
                                                }
                                                setOpenStandard(num);
                                              }} 
                                              >
                                                  <TableCell className='fs12'>{genUID(standard.standardUid)}</TableCell>
                                                  <TableCell className='fs12' sx={{ width: '55%' }}>{standard.standardName}</TableCell>
                                                  <TableCell className='fs12' sx={{ textAlign: 'center' }} onClick={(e) => {e.stopPropagation()}} >
                                                    <Tooltip title={t('VIEW_STANDARDS_DETAIL')} arrow>
                                                      <FontAwesomeIcon 
                                                      className={'icon'} 
                                                      icon={faArrowUpRightFromSquare} 
                                                      onClick={
                                                        () => {
                                                          setDetail(standard);
                                                          setIsOpenStandards(true);
                                                          navigate(`/onsite/sessions/${selectedOnSiteSession?.id}/criteria/${d?.id}/standards/${standard?.standardId}`);
                                                        }
                                                      } />
                                                    </Tooltip>
                                                  </TableCell>
                                                  <TableCell className='fs12'><CommentsDocsActionsIconWrapper actions={standard.noOfActions} comments={standard.noOfComments} docs={standard.noOfEvidences} /></TableCell>
                                                  <TableCell className='fs12'>
                                                      {
                                                          Array.from({length: standard.standardStarRating}, () => <FontAwesomeIcon icon={faStar} style={{color: colors.yellow.bright,}} />)
                                                      }
                                                  </TableCell>
                                                  <TableCell className='fs12'>
                                                      <StatusIndicatorSmall reportType={'siteReview'} status={standard.offSiteStatus} />
                                                  </TableCell>
                                                  <TableCell className='fs12'  onClick={(e) => {e.stopPropagation()}}>
                                                      <SelectBoxPrimary 
                                                      label={''} 
                                                      report={'siteReview'} 
                                                      options={[0, 1, 2, 3]} 
                                                      isStatus={true} 
                                                      manageChange={(e:any) => {updateStatus(e, standard)}}
                                                      selected={standard.status}
                                                      leftPosition={'85% !important'} />
                                                  </TableCell>
                                              </TableRow>
                                              {/* collapsible row for standard details*/}
                                              <TableRow className={(openStandard !== j) ? 'displayNone':''}>
                                                <TableCell colSpan={7}>
                                                  <Collapse in={isOpen == i && selectedOnSiteCriteria?.id == d?.id && openStandard == j}>
                                                    <InterviewStandardDetails detail={detail} manageUpdate={updateOnsiteDetails} />
                                                  </Collapse>
                                                </TableCell>
                                              </TableRow>
                                              </>
                                            )
                                        }) : 
                                        <TableSkeleton rowCount={4} cellCount={6} width={800} />
                                      }
                                  </Table>
                                  }
                                  </Collapse>
                                 </TableCell>
                               </TableRow>
                            </>
                          ))
                        }
                      </TableBody>
                      :
                      (!isFetchingInterviewDetails && interviewDetails && interviewDetails?.length == 0) ?
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={7} className='fs13' sx={{ textAlign: 'center' }} >{t('NO_RECORDS_FOUND')}</TableCell>
                        </TableRow>
                      </TableBody> :
                      <TableBody>
                        <TableSkeleton rowCount={8} cellCount={6} />
                      </TableBody>
                    }
                </Table>
              </TableContainer>
            </Box>
        </React.Fragment>
    )
}

export default InterviewStandards;